import React from 'react';
import { Link } from 'react-router-dom';
import AdminDashboard from '../admin/Dashboard';

export default function DevDashboard() {
  return (
    <div className="space-y-4">
      <div className="rounded-2xl text-white p-6" style={{background:'linear-gradient(135deg,#7c2d12 0%,#c2410c 100%)'}}>
        <h2 className="text-xl font-bold mb-1">⚡ Developer Dashboard</h2>
        <p className="text-orange-200 text-sm">Super Admin — Full System Access</p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {[
          {to:'/developer/theme',icon:'🎨',label:'Theme Settings',color:'bg-purple-50 border-purple-200 text-purple-700'},
          {to:'/developer/system',icon:'⚙️',label:'System Config',color:'bg-blue-50 border-blue-200 text-blue-700'},
          {to:'/developer/rbac/menus',icon:'📋',label:'Menu Manager',color:'bg-green-50 border-green-200 text-green-700'},
          {to:'/developer/rbac/menu-permissions',icon:'🔒',label:'Permissions',color:'bg-red-50 border-red-200 text-red-700'},
        ].map(a => (
          <Link key={a.to} to={a.to} className={`flex flex-col items-center gap-2 p-4 border rounded-xl text-center hover:shadow-md transition-all ${a.color}`}>
            <span className="text-3xl">{a.icon}</span>
            <span className="text-xs font-semibold">{a.label}</span>
          </Link>
        ))}
      </div>
      <AdminDashboard />
    </div>
  );
}
